// src/service/draftService.js
import axios from "axios";
import config from "../environment/config";

const API_URL = `${config.API_URL}/api/seo-product-drafts`;

/**
 * Fetch all drafts
 */
export const fetchDrafts = async () => {
    try {
        const token = localStorage.getItem("jhi-authenticationToken") ||
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("jhi-authenticationToken");

        const headers = {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
        };

        const response = await axios.get(API_URL, { headers });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch drafts:", error);
        throw error;
    }
};

/**
 * Fetch a draft by ID
 */
export const fetchDraftById = async (id) => {
    try {
        const token = localStorage.getItem("jhi-authenticationToken") ||
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("jhi-authenticationToken");

        const headers = {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
        };

        const response = await axios.get(`${API_URL}/${id}`, { headers });
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch draft ${id}:`, error);
        throw error;
    }
};

/**
 * Create a new draft
 */
export const createDraft = async (draft) => {
    try {
        const token = localStorage.getItem("jhi-authenticationToken") ||
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("jhi-authenticationToken");

        const headers = {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
        };

        const response = await axios.post(API_URL, draft, { headers });
        return response.data;
    } catch (error) {
        console.error("Failed to create draft:", error);
        throw error;
    }
};

/**
 * Update an existing draft
 */
export const updateDraft = async (id, draft) => {
    try {
        const token = localStorage.getItem("jhi-authenticationToken") ||
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("jhi-authenticationToken");

        const headers = {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
        };

        const response = await axios.put(`${API_URL}/${id}`, draft, { headers });
        return response.data;
    } catch (error) {
        console.error(`Failed to update draft ${id}:`, error);
        throw error;
    }
};

/**
 * Delete a draft
 */
export const deleteDraft = async (id) => {
    try {
        const token = localStorage.getItem("jhi-authenticationToken") ||
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("jhi-authenticationToken");

        const headers = {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
        };

        await axios.delete(`${API_URL}/${id}`, { headers });
        return true;
    } catch (error) {
        console.error(`Failed to delete draft ${id}:`, error);
        throw error;
    }
};

/**
 * Fetch drafts by username
 */
export const fetchDraftsByUser = async (username) => {
    try {
        const token = localStorage.getItem("jhi-authenticationToken") ||
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("jhi-authenticationToken");

        const headers = {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
        };

        const response = await axios.get(`${API_URL}/user/${username}`, { headers });
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch drafts for user ${username}:`, error);
        throw error;
    }
};
